import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

interface ThemeToggleProps {
  className?: string;
  showLabel?: boolean;
  onClick?: () => void;
}

/**
 * Renders a button that toggles between light and dark themes.
 *
 * The button updates its icon, accessible label, and styling based on the current theme. Clicking the button switches to the opposite theme.
 *
 * @param className - Optional additional CSS classes for custom styling.
 */
export default function ThemeToggle({ showLabel = false, onClick }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();
  
  const handleClick = () => {
    toggleTheme();
    if (onClick) onClick();
  };

  return (
    <div className="flex items-center w-full" onClick={handleClick}>
      <div
        className="relative flex items-center justify-center w-8 h-8"
        aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
        data-component-name="ThemeToggle"
      >
        {theme === 'dark' ? (
          <Sun className="w-8 h-8" />
        ) : (
          <Moon className="w-8 h-8" />
        )}
      </div>
      {showLabel && (
        <span className="ml-3">
          {theme === 'light' ? 'Dark' : 'Light'}
        </span>
      )}
    </div>
  );
}
